module.exports = __webpack_public_path__ + "static/media/done.9d37e8f3.svg";